import React, { useState, useEffect } from 'react'

const marketoScriptId = 'mktoForms'

export default function FormBasic({ id, url, title }) {
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    if (!document.getElementById(marketoScriptId)) {
      loadScript()
    } else {
      setIsLoaded(true)
    }
  }, [])

  useEffect(() => {
    isLoaded &&
      window.MktoForms2.loadForm('//info.edwards.com', '769-NOZ-917', id, function (form){
      // Set values in hidden field to determine asset to serve
      form.vals({ "test1": title });
      form.vals({ "FormLocal": url });
      form.vals({ "test2": url });
      form.vals({ "product": title });
      // Override redirect URL set in Marketo
      form.onSuccess(function(values, followUpUrl) {
        if(typeof window !== "undefined") {
          //on successful submit, send mktoLead event with formID to Google Tag Manager
          window.dataLayer.push({event:'mktoLead',id});
          window.location.href = url;
        }
        // Return false to prevent the submission handler continuing with its own processing
        return false;
      });
    })
  }, [isLoaded, id])

  const loadScript = () => {
    let s = document.createElement('script')
    s.id = marketoScriptId
    s.type = 'text/javascript'
    s.async = true
    s.src = '//info.edwards.com/js/forms2/js/forms2.min.js'
    s.onreadystatechange = function () {
      if (this.readyState === 'complete' || this.readyState === 'loaded') {
        setIsLoaded(true)
      }
    }
    s.onload = () => setIsLoaded(true)
    document.getElementsByTagName('head')[0].appendChild(s)
  }

  return <form id={`mktoForm_${id}`}></form>
}
